import { render, staticRenderFns } from "./token-form.vue?vue&type=template&id=a3e21f14&scoped=true"
import script from "./token-form.vue?vue&type=script&lang=ts"
export * from "./token-form.vue?vue&type=script&lang=ts"
import style0 from "./token-form.vue?vue&type=style&index=0&id=a3e21f14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e21f14",
  null
  
)

export default component.exports